import { DiscountEndpoints } from '@/modules/inventory/discount/api/discountEndpoints'

/**
 * Discount endpoint instance
 * instantiate discount api class with different api path
 */
export const discountEndpoints = new DiscountEndpoints()
